import { createSlice } from '@reduxjs/toolkit';

import * as clientApi from '../services/clientApi';

export const usersSlice = createSlice({
  name: 'usersList',
  initialState: [],
  reducers: {
    set: (_, action) => action.payload,
    add: (users, action) => [...users, action.payload],
    update: (users, { payload: { id, ...user } }) =>
      users.map(a => (a.id !== id ? a : { ...a, ...user })),
    remove: (users, action) => users.filter(c => c.id !== action.payload),
  },
});

export const { set, add, update, remove } = usersSlice.actions;

export const fetchAllUsers = token => dispatch => {
  return clientApi.getAllUsers(token).then(users => dispatch(set(users)));
};

export const createUser = (user, token) => dispatch => {
  return clientApi.createUser(user, token).then(user => dispatch(add(user)));
};

export const updateUser = (user, token) => dispatch => {
  return clientApi.updateUser(user, token).then(_ => dispatch(update(user)));
};

export const deleteUser = (userId, token) => dispatch => {
  return clientApi
    .deleteUser(userId, token)
    .then(_ => dispatch(remove(userId)));
};

export default usersSlice.reducer;
